<template>
  <div class="select">
    <div class="wrapper">
      <div class="container">
        <div class="left">
          <div class="content">
            <back-action />
            <h1>Waar wil je aan bijdragen?</h1>
          </div>
        </div>
        <div class="right">
          <div class="content" id="main">
            <div class="inner">
              <div class="rows">
                <router-link
                  to="/mobiliteitsprojecten-voor-jongerenwerkers"
                  class="col"
                >
                  <div class="col__rows">
                    <div class="col__rows--left">
                      <span class="title">De ontwikkeling van jongerenwerkers</span>
                      <span class="sub">Ik wil een training of netwerkactiviteit opzetten voor (vrijwillige) jongerenwerkers van mijn eigen organisatie en uit andere landen.</span>
                    </div>
                    <div class="col__rows--right">
                      <button class="button">Maak keuze</button>
                    </div>
                  </div>
                </router-link>
                <router-link
                  to="/sector/jeugd/organisatie/ontwikkeling-organisatie/ervaringen-uitwisselen"
                  class="col"
                >
                  <div class="col__rows">
                    <div class="col__rows--left">
                      <span class="title">Het (internationale) jeugd- en jongerenwerk</span>
                      <span class="sub">Ik wil ervaringen uitwisselen en/of werken aan innovatieve methodes voor het (internationale) jeugd- en jongerenwerk.</span>
                    </div>
                    <div class="col__rows--right">
                      <button class="button">Maak keuze</button>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
